import PropTypes from 'prop-types';
import { biometricProp } from '../pages/Scout/Scout.proptypes';

// GET_TEAMS
export const teamDetailsPropTypes = PropTypes.shape({
  // colour hex codes
  colorPrimary: PropTypes.string,
  colorSecondary: PropTypes.string,
  colorTertiary: PropTypes.string,
  gameCount: PropTypes.number,
  id: PropTypes.number,
  // team name: Arizona Cardinals
  name: PropTypes.string,
  // team short name: ARI
  shortName: PropTypes.string,
});

export const playerDetailsPropTypes = PropTypes.shape({
  gamesRostered: PropTypes.number,
  id: PropTypes.number,
  mostCommonNumber: PropTypes.number,
  mostCommonPosition: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    code: PropTypes.string,
    generalPosition: PropTypes.string,
  }),
  name: PropTypes.string,
});

// Scout Setups
export const uiScoutSetupsPropTypes = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  creator: PropTypes.string,
  creatorId: PropTypes.string,
  created: PropTypes.number,
  lastEditor: PropTypes.string,
  lastModified: PropTypes.number,
  selectedBiometrics: PropTypes.arrayOf(biometricProp),
  selectedPositions: PropTypes.arrayOf(PropTypes.string),
  selectedStats: PropTypes.arrayOf(
    PropTypes.shape({
      abbreviation: PropTypes.string,
      description: PropTypes.string,
      key: PropTypes.string,
      lowerIsBetter: PropTypes.bool,
      max: PropTypes.number,
      min: PropTypes.number,
      name: PropTypes.string,
      sliderStep: PropTypes.number,
      steps: PropTypes.number,
      value: PropTypes.number,
    }),
  ),
});
